module.exports = __webpack_public_path__ + "static/media/app-development-active.aaf7981d.png";